// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import FieldErrorStyled from "./FieldError.styled";

const Error = ({ error, id }) => {
    return <FieldErrorStyled id={id} data-testid={id}>{error}</FieldErrorStyled>;
};

export default Error;

// props validation
Error.propTypes = {
    error: PropTypes.string.isRequired,
	id: PropTypes.string
};
